import { FC } from 'react';

interface DotsProgressLineProps {
  numerator: number;
  denominator: number;
}

const DotsProgressLine: FC<DotsProgressLineProps> = ({ numerator, denominator }) => {
  // Calculate fill percentage for the blue track, avoiding division by zero
  const numeratorClamped = Math.min(Math.max(numerator, 0), denominator);
  const denominatorClamped = Math.max(1, denominator);
  const progressPercent = (Math.max(numeratorClamped - 1, 0) / Math.max(denominatorClamped - 1, 1)) * 100;

  return (
    <div className="tw-relative tw-flex tw-items-center">
      {/* Gray track */}
      <div className="tw-absolute tw-inset-x-0 tw-top-1/2 tw-h-1 tw-bg-neutral-300 tw--translate-y-1/2 tw-z-0" />

      {/* Dots with highlights */}
      {Array.from({ length: denominator }).map((_, idx) => {
        const isCompleted = idx < numeratorClamped;

        return (
          <div key={idx} className={`tw-relative tw-flex-shrink-0 ${idx > 0 ? 'tw-ml-4' : ''}`}>
            {isCompleted && (
              <div className="tw-absolute tw-inset-0 tw-transform tw-scale-150 tw-rounded-full tw-bg-blue-50" />
            )}
            <div
              className={`tw-w-3 tw-h-3 tw-rounded-full tw-relative ${
                isCompleted ? 'tw-bg-blue-300' : 'tw-bg-neutral-300'
              }`}
            />
          </div>
        );
      })}

      {/* Blue track up to last completed dot */}
      <div
        className="tw-absolute tw-left-0 tw-top-1/2 tw-h-1 tw-bg-blue-300 tw--translate-y-1/2"
        style={{ width: `${progressPercent}%` }}
      />
    </div>
  );
};

export default DotsProgressLine;
